import React from "react";
import HeroSection from "../components/HeroSection";
import AboutArea from "../components/AboutArea";
import MeetFaculty from "../components/MeetFaculty";
import Courses from "../components/Courses";
import IndustrialConnects from "../components/IndustrialConnects";
import Welcome from "../components/Welcome";
import MainPage from "../components/MainPage";
import Cards from "../components/Cards";
import Links from "../components/Links";

const Home = () => {
  return (
    <div className="bg-[#FFF;]">
      {/* <HeroSection /> */}
      <MainPage/>
      <Links/>
  <Cards/>
      <Welcome />
      <AboutArea />
      {/* <MeetFaculty /> */}
      <Courses />
      <IndustrialConnects />
    </div>
  );
};

export default Home;
